import React, { useEffect } from "react"
import { withOrientationChange } from "react-device-detect"

import { sanitizeInnerHtml, cleanHtmlTextForDatalayer } from "@/utils/helper"

import Button from "@/components/core/Button/Button"
import { addDataLayer } from "../analytics"

const TradeMembershipConfirmation = props => {
  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    })
  }, [])

  return (
    <div className="trade-membership-confirmation-message-wrapper">
      <div className="kf-react-container">
        <div className="trade-membership__success-message">
          <div
            id="trade-membership-success-message"
            className="message-content"
            tabIndex="0"
          >
            <div className="success-message-body">
              {sanitizeInnerHtml(props.i18n.messageSent)}
            </div>
          </div>
          <div className="trade-membership-response-message">
            <div className="response-message-body">
              {sanitizeInnerHtml(props.i18n.responseReceiveTime)}
            </div>
            <Button
              type="black"
              target={props?.isNewTab ? "_blank" : "_self"}
              label={props.i18n.startShopping}
              to={props?.continueShoppingUrl}
              className="start-shopping-btn"
              onClick={() =>
                addDataLayer({
                  isLink: true,
                  clickInternalLinks: props?.getInternalLinkURLS(
                    props.continueShoppingUrl
                  ),
                  title: props.i18n.startShopping?.toLowerCase(),
                  formTitle: cleanHtmlTextForDatalayer(props.i18n.messageSent),
                  url: props?.continueShoppingUrl
                    ? (props?.continueShoppingUrl.indexOf("http") === -1
                        ? window.location.origin
                        : "") + props?.continueShoppingUrl
                    : "n/a",
                })
              }
            />
          </div>
        </div>
      </div>
    </div>
  )
}

export default withOrientationChange(TradeMembershipConfirmation)
